import * as AuthenticationRepo from '../Authentication.repo'
import { STAYMASKED_TOKEN_COOKIE_NAME, PAYLAH_UUID_COOKIE_NAME } from '../../../Constants'

export const logout = async (cookies, token) => {
  await AuthenticationRepo.logout(token)
  cookies.remove(STAYMASKED_TOKEN_COOKIE_NAME)
  cookies.remove(PAYLAH_UUID_COOKIE_NAME)
}
